import { Box } from '@n26/nxd'

export const SectionWrapper = ({
  children,
  asSection = true,
}: {
  children: React.ReactNode
  asSection?: boolean
}) => {
  return (
    <Box
      as={asSection ? 'section' : undefined}
      className='max-w-blog-home w-full px-24 lg:px-0'
    >
      {children}
    </Box>
  )
}
